import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";

import {USER_LOCALSTORAGE_KEY} from "shared/const/localstorage";


import {ApiLessonsResponse} from "../../../types/lessosnSchema";
import {setLessons} from "../../../slice/groups/set-lessons/setLessons";
import {setResponseSubscribedLessonId} from "../../../slice/lessons/lessons-demo/setLessonsDemo";



export const fetchLessonsId = createAsyncThunk(
    "lessons/fetchLessonsId",
    async (lessonsId: string  | undefined | number, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }
            const { token } = JSON.parse(authToken);


            const response = await axios.get<ApiLessonsResponse>(`/api/lessons/${lessonsId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.data && response.data.success) {

                thunkAPI.dispatch(setLessons(response.data.data));
                thunkAPI.dispatch(setResponseSubscribedLessonId(response.data.subscribedLessonId));



            }

            // You can dispatch additional actions here if needed

            return response.data;
        } catch (e) {
            return thunkAPI.rejectWithValue("error");
        }
    }
);
